import { useMutation } from '@tanstack/react-query';
import type { AgentApiCandidateChatMessagesRecord } from '@/types/serializers';

type Request = {
  candidateProfileId: number;
  content: string;
  file?: File | null;
};

export default function useCreateCandidateChatMessage() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async ({ candidateProfileId, content, file }: Request) => {
      const formData = new FormData();
      formData.append('content', content);
      if (file) {
        formData.append('file', file);
      }

      const response = await fetch(
        `/agent/api/candidate_profiles/${candidateProfileId}/candidate_chat_messages`,
        {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-CSRF-Token': token,
          },
          body: formData,
        }
      );

      if (!response.ok) {
        throw new Error('メッセージの送信に失敗しました');
      }

      const data: AgentApiCandidateChatMessagesRecord = await response.json();
      return data;
    },
  });
}
